import { useCurrentWorkflowStore } from '@/stores/workflow/currentWorkflow';
import { computed, ref } from 'vue';

export const useActionCard = () => {
  const workflowStore = useCurrentWorkflowStore();

  const showNoActions = ref<boolean>(workflowStore.currentWorkflow.workflow_actions.length === 0);
  const showAddAction = ref<boolean>(false);

  const handleAddAction = async () => {
    showNoActions.value = false;
    showAddAction.value = true;
  };

  const sortedActions = computed(() => {
    const actions = workflowStore.currentWorkflow.workflow_actions ?? [];
    return [...actions].sort((a, b) => {
      if (a.invocation === 'immediate' && b.invocation !== 'immediate') return -1;
      if (b.invocation === 'immediate' && a.invocation !== 'immediate') return 1;

      if (a.invocation === 'scheduled' && b.invocation === 'scheduled') {
        return (
          (a.workflow_scheduled_action?.delay_in_minutes ?? 0) - (b.workflow_scheduled_action?.delay_in_minutes ?? 0)
        );
      }

      return 0;
    });
  });

  return { sortedActions, showAddAction, showNoActions, handleAddAction };
};
